

import { RealImageInfo } from '../typings/model/chat';
import { ImageInfo } from '../typings/proto';

interface GetImageInfoResult {
  width: number;
  height: number;
}

/**
 * 获取图片信息
 * @param imagePath 图片路径
 * @returns 图片信息
 */
export function getImageInfo(imagePath: string): Promise<GetImageInfoResult> {
  const img = new Image();
  return new Promise((resolve, reject) => {
    img.onload = function () {
      const result: GetImageInfoResult = {
        width: img.width,
        height: img.height,
      };

      resolve(result);
    };
    img.onerror = reject;
    img.src = imagePath;
  });
}

/**
 * 预加载图片
 * @param imageUrl 图片路径
 * @returns Promise
 */
export function preloadImage(imageUrl: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const oImage = new Image();
    oImage.src = imageUrl;
    oImage.onload = () => {
      resolve();
    };
    oImage.onerror = () => {
      reject();
    };
  });
}

interface GenerateRealImageOptions {
  maxImageWidth: number;
  maxImageHeight: number;
  minImageWidth: number;
  minImageHeight: number;
}

/**
 * 生成真实图片参数
 * @param imgInfo
 */
export function generateRealImage(imgInfo: ImageInfo, options: GenerateRealImageOptions): RealImageInfo {
  const { width, height } = imgInfo;
  const { max } = Math;

  let calWidth = 0.0;
  let calHeight = 0.0;

  if (!height || !width) {
    // 如果照片的宽度和高度有一个异常,
    calWidth = options.maxImageWidth;
    calHeight = calWidth;
  } else if (width / height < 0.7) {
    // 长图,高度容器已固定，宽度自适应,确定容器大小
    calHeight = options.maxImageHeight;
    calWidth = max(options.minImageWidth, width / (height / options.maxImageHeight));
  } else {
    // 宽图+方图
    calWidth = options.maxImageWidth;
    calHeight = max(options.minImageHeight, height / (width / options.maxImageWidth));
  }
  return Object.assign({}, imgInfo, {
    realWidth: calWidth,
    realHeight: calHeight,
  });
}
